<script>
const axios = require('axios')
const aws4 = require('aws4');

export default { 
  props: ['owner'],
  created: function(){
    
  }, 
  data: function(){
    return{
      pre:  '/Stage',
      host: process.env.VUE_APP_HOST,
    }
  },
  methods: {  
    
    call: async function (endpoint, data, successHandler, errorHandler, method, contentType) {

      if(!navigator.onLine){
        this.owner.showModalOK({message: 'We are unable to detect an Internet Connection, please connect to the Internet and try again.'})
        return
      }

      var self = this;

      let dt = new Date()
      let expDt = new Date(self.owner.timer);

      var currCreds = JSON.stringify(self.owner.creds);

      function waitFor(conditionFunction) {
        const poll = resolve => {
          console.log('poll')
          if(conditionFunction()) resolve();
          else setTimeout(() => poll(resolve), 200);
        }
        return new Promise(poll);
      }
     
      if(dt.getTime() > expDt.getTime()){
        if(self.owner.isAuth){
          self.owner.showModalFullSpinner()
          await self.owner.azCognito.refreshSession()
          await waitFor(() => {
            return currCreds != JSON.stringify(self.owner.creds)
          });
          self.owner.hideModalFullSpinner()
          //// INSERT APP HOOK to copy local storage
          if(self.owner.inApp)
           window.webkit.messageHandlers.myMessageName.postMessage("writeLocal")
        }
      }
     
      self.owner.startTimer()

      var path = '/' + endpoint //process.env.ROOT_API + endpoint;

      //TODO: For Dev only, remove for prod
      if(contentType == 'static'){
        path = "/static/" + endpoint;
      }
     
      var signedRequest = {}
      if(contentType != 'static'){
        let request = {
            host: this.host,
            method: method.toUpperCase(),
            path: `${this.pre}${path}`,
            url: `https://${this.host}${this.pre}${path}`,
            //withCredentials: true,
            headers: {'Access-Control-Allow-Origin' : '*'},
            timeout: 0
        }

        if(method == "POST" || method == 'PUT' || method == 'DELETE'){
            request.body = JSON.stringify(data);
            request.data = data;
            request.headers = {'access-control-allow-origin' : '*', 'content-type' : 'application/json'};
        }

        signedRequest = aws4.sign(request, self.owner.creds);

        delete signedRequest.headers['Content-Length']
        delete signedRequest.headers['Host']
          
      } else {
           signedRequest = {
              method: method,
              url: path,
              data: ''
          }
      }

  
    



      axios(
        signedRequest
        )
        .then(function (response) {
          /* console.log(response)
          if(response.status == 'net::ERR_NETWORK_DISCONNECTED'){
            self.$root.app.showModalOK({message: 'We are unable to detect an Internet Connection, please connect to the Internet and try again.'})
            return
          } */

          var data = response.data;
          var status = response.status;
          var statusText = response.statusText;
          var headers = response.headers
          var config = response.config;
          successHandler(data, status, statusText, headers, config)
        })
        .catch(function (error) {
       
       
        /*   if(error.response == undefined){
            
            if(error.Error = 'Network Error'){
              self.owner.showModalOK({message: 'We are unable to detect an Internet connection. Please connect to the Internet and try again.'})
              return
            }
           
            errorHandler(false)
            return
          } */

         /*  var errorRequest, headers
          if(error.response){
             data = error.response.data;
             status = error.response.status ;
             headers = error.response.headers;
          } else if(error.request){
            errorRequest = error.request;
          }
          var config = error.config;
          var msg = error.message; */
          errorHandler()
        });
    },
    get: function (path, data, successHandler, errorHandler, contentType) {
      this.call(path, data, successHandler, errorHandler, "GET", contentType);
    },

    post: function (path, data, successHandler, errorHandler, contentType) {
      this.call(path, data, successHandler, errorHandler, "POST", contentType);
    },

    delete: function (path, data, successHandler, errorHandler, contentType) {
      this.call(path, data, successHandler, errorHandler, "DELETE", contentType);
    },

    put: function (path, data, successHandler, errorHandler, contentType) {
      this.call(path, data, successHandler, errorHandler, "PUT", contentType);
    }
  }
}
</script>
